import LegalPage from "./LegalPage";

export default function Refund() {
  return (
    <LegalPage
      testId="refund-page"
      title="Refund"
      accent="Policy."
      effective="January 25, 2026"
      sections={[
        {
          heading: "Company Disclosure",
          body: [
            "JC3 Wealth Legacy Group LLC is a financial consulting firm. We do not guarantee specific results. Individual outcomes vary based on your financial profile, third-party institution criteria, and client cooperation. We are not a credit repair organization and we are not a lender or funding company.",
          ],
        },
        {
          heading: "General Policy",
          body: [
            "Except for the cancellation rights described below, fees for services already performed are non-refundable. Consulting time, strategy, and frameworks cannot be returned once they have been delivered.",
          ],
        },
        {
          heading: "Your Cancellation Rights",
          body: [
            "You may cancel any service agreement with JC3 Wealth Legacy Group LLC, without penalty and for a full refund of any amounts paid, at any time within three (3) business days after the date you sign your engagement agreement. To cancel, email jace@jc3wealthlegacy.com with the subject line CANCEL before midnight of the third business day.",
            "For Financial Profile Development services, you are billed monthly in arrears: each monthly fee is charged only after that month's services have been performed. You may cancel Financial Profile Development at any time, effective at the end of the current service month, with no cancellation fee.",
          ],
        },
        {
          heading: "Once Service Delivery Begins",
          body: [
            "For one-time and fixed-scope services, after service delivery begins (including but not limited to scheduling a kickoff call, reviewing your consumer report information with your authorization, receiving a strategy document, or beginning the financial profile development process), no refunds will be issued for that deliverable. This does not limit Your Cancellation Rights above, including the three (3) business-day cancellation right and the monthly-in-arrears cancellation of Financial Profile Development.",
          ],
        },
        {
          heading: "3% Processing Fee",
          body: [
            "Outside the three (3) business-day cancellation window, the 3% credit card processing fee is non-refundable. Debit card payments are not charged this fee. This fee is charged to JC3 Wealth Legacy Group by our payment processor and cannot be reclaimed.",
          ],
        },
        {
          heading: "Non-Refundable Items",
          body: ["The following are non-refundable in all circumstances:"],
          bullets: [
            "Completed financial profile analyses",
            "Delivered strategy documents and roadmaps",
            "Consulting sessions already conducted",
            "Financial Profile Development fees for any service month already performed",
            "Digital materials and downloadable resources",
          ],
        },
        {
          heading: "Third-Party Fees",
          body: [
            "Certain services require fees that we pay to third parties on your behalf — including state filing fees for Business Foundation Setup and application or submission fees for Grant Readiness & Research. Once these third-party fees have been paid out, they are non-refundable, regardless of any other cancellation or refund right, because they are not returned to us by the third party.",
          ],
        },
        {
          heading: "Dissatisfaction",
          body: [
            "If you are dissatisfied with any aspect of our service, please contact us before requesting a refund or initiating a chargeback. We are committed to addressing concerns directly and will work in good faith to resolve any issue.",
          ],
        },
        {
          heading: "How to Request a Refund",
          body: [
            { html: 'To request a refund, email <a class="text-jc-gold underline decoration-jc-gold/40 hover:decoration-jc-gold" href="mailto:jace@jc3wealthlegacy.com?subject=Refund%20Request">jace@jc3wealthlegacy.com</a> with: your full name, the date of purchase, the service purchased, and the reason for the refund request. We will respond within three (3) business days. Approved refunds are processed to the original payment method within five to ten (5-10) business days after approval.' },
          ],
        },
        {
          heading: "Chargebacks",
          body: [
            "Chargebacks initiated without first contacting us will be disputed with full documentation of the services rendered. We encourage all clients to reach out directly so that we can resolve any concerns promptly.",
          ],
        },
        {
          heading: "Contact",
          body: [
            { html: 'For refund questions or to submit a request, email <a class="text-jc-gold underline decoration-jc-gold/40 hover:decoration-jc-gold" href="mailto:jace@jc3wealthlegacy.com?subject=Refund%20Request">jace@jc3wealthlegacy.com</a>.' },
            { html: 'JC3 Wealth Legacy Group LLC · Atlanta, Georgia · <a class="text-jc-gold underline decoration-jc-gold/40 hover:decoration-jc-gold" href="tel:+14708887331">470-888-7331</a>' },
          ],
        },
      ]}
    />
  );
}
